import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to handle highlighting sections when navigating from search results
 * Looks for hash in URL and highlights the corresponding section
 */
export function useSearchHighlight() {
	const location = useLocation();

	useEffect(() => {
		// Check if there's a hash in the URL
		if (location.hash) {
			const sectionId = location.hash.substring(1); // Remove the #
			const element = document.querySelector(`[data-section-id="${sectionId}"]`);
			
			if (element) {
				// Small delay to ensure page content is rendered
				setTimeout(() => {
					element.scrollIntoView({ behavior: 'smooth', block: 'center' });
					// Add highlight class
					element.classList.add('search-highlight');
					
					// Remove highlight after animation
					setTimeout(() => {
						element.classList.remove('search-highlight');
						// Clean up URL hash after highlighting
						window.history.replaceState(null, '', location.pathname);
					}, 2000);
				}, 100);
			}
		}
	}, [location.hash, location.pathname]);
}

